import { render, staticRenderFns } from "./DetailOrderPopup.vue?vue&type=template&id=57c74760&scoped=true&"
import script from "./DetailOrderPopup.vue?vue&type=script&lang=js&"
export * from "./DetailOrderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c74760",
  null
  
)

export default component.exports